<script setup lang="ts">
import { ref } from "vue";
import { onMounted } from "vue";
import $ls, { LocalStorageKey } from "@/utils/local-storage";

import { useRouter } from "vue-router";

import { useLanguage } from "@/composable/useLanguage";
import DRLogo from "@/components/UI/DRLogo.vue";

useLanguage();

const router = useRouter();
onMounted(() => {
  const jwt = $ls.getItem(LocalStorageKey.JWT);
  if (jwt) {
    router.replace({ name: "home" });
  }
});

const activeTab = ref(router.currentRoute.value.name);

function toggleTab(tabname: string) {
  activeTab.value = tabname;
}
</script>

<template>
  <div class="container mt-5 tab-container">
    <div class="d-flex justify-content-center mb-4 welcome-logo">
      <DRLogo />
    </div>

    <ul class="nav nav-tabs justify-content-center">
      <li class="nav-item">
        <router-link
          :to="{ name: 'login' }"
          @click="toggleTab('login')"
          class="nav-link"
          :class="{ active: activeTab === 'login' }"
        >
          {{ $t("auth:login.title") }}
        </router-link>
      </li>
    </ul>
    <RouterView></RouterView>
  </div>
</template>

<style scoped>
.tab-container {
  max-width: 500px !important;
}

body {
  background-color: white !important;
}
</style>
